<script setup>
import { isVNode, computed } from 'vue';
import Icon from 'next/icon/Icon.vue';
import Policy from 'dashboard/components/policy.vue';
import { useSidebarContext } from './provider';
import SidebarUnreadBadge from './SidebarUnreadBadge.vue';

const props = defineProps({
  label: { type: String, required: true },
  to: { type: [String, Object], required: true },
  icon: { type: [String, Object], default: null },
  active: { type: Boolean, default: false },
  component: { type: Function, default: null },
  badgeCount: { type: [Number, String], default: 0 },
});

const { resolvePermissions, resolveFeatureFlag } = useSidebarContext();

const shouldRenderComponent = computed(() => {
  return typeof props.component === 'function' || isVNode(props.component);
});
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <Policy
    :permissions="resolvePermissions(to)"
    :feature-flag="resolveFeatureFlag(to)"
    as="li"
    class="child-item relative min-w-0 py-0.5 text-[rgb(var(--whaisper-shell-copy))] before:left-0 before:bg-[rgb(var(--whaisper-shell-border))] after:border-[rgb(var(--whaisper-shell-border))] after:bg-transparent ltr:ml-3 ltr:pl-3 rtl:mr-3 rtl:pr-3 rtl:before:right-0"
  >
    <component
      :is="to ? 'router-link' : 'div'"
      :to="to"
      :title="label"
      class="group flex h-9 min-w-0 items-center gap-2 rounded-xl border border-transparent px-3 py-1.5 transition-colors duration-150"
      :class="{
        'border-[rgb(var(--whaisper-shell-border))] bg-[rgb(var(--whaisper-shell-panel-muted)/0.72)] text-[rgb(var(--whaisper-shell-heading))] shadow-sm':
          active,
        'hover:border-[rgb(var(--whaisper-shell-border))] hover:bg-white/65':
          !active,
      }"
    >
      <component
        :is="component"
        v-if="shouldRenderComponent"
        v-bind="{ label, icon, active, badgeCount }"
      />
      <template v-else>
        <Icon v-if="icon" :icon="icon" class="inline-block size-4" />
        <div class="min-w-0 flex-1 truncate">{{ label }}</div>
        <SidebarUnreadBadge :count="badgeCount" />
      </template>
    </component>
  </Policy>
</template>
